<div
  *ngIf="isDesktop && (patient$ | async)?.verifiedHipaa"
  class="select-none"
  data-cy="user-menu-container"
  #userMenuContainer
  tabindex="0"
>
  <div
    attr.alt="{{ (patient$ | async)?.fullName | titlecase }} Patient ID: {{ (patient$ | async)?.id }}"
    class="flex align-items-center cursor-pointer"
    (click)="toggleUserMenu()"
    data-cy="user-menu-toggle-button"
  >
    <p-avatar
      class="mr-2"
      [label]="(patient$ | async)?.initials || ''"
      styleClass="user-menu-avatar-small user-{{
        !!(selectedPatientIndex$ | async) ? (selectedPatientIndex$ | async)! % 3 : 0
      }}"
      shape="circle"
      data-cy="user-menu-avatar"
    ></p-avatar>
    <div class="flex flex-column">
      <div class="my-0 p4 font-normal" data-cy="patient-name">
        {{ (patient$ | async)?.fullName | titlecase }}
      </div>
      <div class="my-0 p4 font-normal black-400" data-cy="patient-id">Patient ID: {{ (patient$ | async)?.id }}</div>
    </div>
    <i
      class="pi pi-angle-down ml-2"
      [class]="userMenuVisible ? 'active-arrow' : ''"
      data-cy="user-menu-toggle-icon"
    ></i>
  </div>

  <p-panel
    *ngIf="userMenuVisible"
    class="top-0 right-0 mt-8 w-16rem absolute flex flex-column"
    [showHeader]="false"
    data-cy="user-menu-dropdown"
  >
    <div class="py-2">
      <div
        class="p3 font-medium py-2 px-3 cursor-pointer menu-item"
        routerLink="/profile"
        data-cy="user-menu-profile-link"
        (click)="toggleUserMenu()"
      >
        Patient Profile
      </div>
      <div *ngIf="(isAgentUser$ | async) !== true">
        <div
          *ngIf="!!(patients$ | async)?.data && (patients$ | async)!.data!.length > 1"
          class="flex justify-content-between align-items-center py-2 px-3 cursor-pointer"
          (click)="toggleSwitchPatientMenu()"
          data-cy="user-menu-switch-patient-toggle"
        >
          <span class="p3 font-medium">Switch Patient</span>
          <i *ngIf="switchPatientMenuVisible" class="pi pi-angle-down"></i>
          <i *ngIf="!switchPatientMenuVisible" class="pi pi-angle-right"></i>
        </div>
        <div
          *ngIf="!!(patients$ | async)?.data && (patients$ | async)!.data!.length > 0 && switchPatientMenuVisible"
          data-cy="switch-patient-menu-container"
        >
          <div
            *ngFor="let currPatient of (patients$ | async)?.data || []; let i = index"
            class="flex align-items-center switch-patient-menu-item py-2 px-3"
            [class]="currPatient.id === (patient$ | async)?.id ? 'active' : ''"
            (click)="switchPatient(currPatient.id)"
            data-cy="user-menu-switch-patient-menu-item"
          >
            <p-avatar
              class="mr-2"
              [label]="currPatient.initials || ''"
              styleClass="user-menu-avatar-small user-{{ i % 3 }}"
              shape="circle"
              size="small"
              data-cy="switch-patient-menu-item-avatar"
            ></p-avatar>
            <div class="flex flex-column">
              <div class="p4 font-normal" data-cy="switch-patient-item-patient-name">
                {{ currPatient.fullName | titlecase }}
              </div>
              <div class="p4 font-normal text-grey-500" data-cy="switch-patient-item-patient-id">
                Patient ID: {{ currPatient.id }}
              </div>
            </div>
            <i
              *ngIf="currPatient.id === (patient$ | async)?.id"
              class="pi pi-check ml-auto primary-blue-500"
              data-cy="switch-patient-item-icon"
            ></i>
          </div>
        </div>
        <p-divider styleClass="my-2 px-3"></p-divider>
        <div class="flex py-2 px-3 align-items-center">
          <div class="my-0 p4 font-normal truncated" data-cy="account-email">
            {{ (authenticatedUser$ | async)?.email || '' }}
          </div>
        </div>

        <div
          class="p3 font-medium py-2 px-3 cursor-pointer menu-item"
          routerLink="/account"
          data-cy="user-menu-account-link"
          (click)="toggleUserMenu()"
        >
          Manage Account
        </div>
        <p-divider styleClass="my-2 px-3"></p-divider>
        <div
          class="p3 font-medium py-2 px-3 primary-blue-500 cursor-pointer menu-item"
          (click)="signOut()"
          data-cy="user-menu-sign-out-button"
        >
          Sign Out
        </div>
      </div>
    </div>
  </p-panel>
</div>
